
import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';
import Popper from 'popper.js';


import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import 'react-tooltip/dist/react-tooltip.css'

import 'bootstrap/dist/js/bootstrap.min.js'
// import "bootstrap/dist/js/bootstrap.bundle.min";
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import 'react-phone-input-2/lib/bootstrap.css';
import 'maplibre-gl/dist/maplibre-gl.css';
// import "draft-js/dist/Draft.css";

window.$ = $;
window.jQuery = $;
window.PerfectScrollbar = PerfectScrollbar;
window.Popper = Popper

import { AuthProvider } from './components/master/AuthProvider.jsx'
import { Bounce, ToastContainer } from 'react-toastify';
import CONFIGURACIONES from './util/constants';
import {ZonaAgenciaProvider} from "./components/context/ZonaAgenciaContext.jsx";

ReactDOM.createRoot(document.getElementById('root')).render(
    // <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <ZonaAgenciaProvider>
                    <App />
                    <ToastContainer
                        autoClose={CONFIGURACIONES.INIT.TOAST_CLOSE}
                        limit={1}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick={false}
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                        transition={Bounce}
                    />
                </ZonaAgenciaProvider>
            </AuthProvider>
        </BrowserRouter>
     
    // </React.StrictMode>
)
